import React from 'react';
import axios from 'axios';
import { InlineNotification } from 'carbon-components-react';
import { t } from '../../../RI18n';
import './ReportStatus.css';
import ReportStatusWithRowCount from './ReportStatusWithRowCount';

class ReportStatusList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      reportList: [],
      error: null,
      errorFromItem: null,
    };
    this.signal = axios.CancelToken.source();
  }

  componentDidMount() {
    axios
      .get('/status_widgets.json?details=true', {
        cancelToken: this.signal.token,
      })
      .then((result) => {
        const currentReportList = result.data.map(
          (item, idx) => { const currentItem = item; currentItem.idx = idx; return currentItem; },
        );
        this.setState({
          reportList: currentReportList,
        });
      })
      .catch((err) => {
        if (axios.isCancel(err)) return; // request aborted
        console.log(err);
        this.setState({
          error: true,
        });
      });
  }

  componentWillUnmount() {
    this.signal.cancel();
  }

  callbackOnReportItemError = () => {
    this.setState({ errorFromItem: true });
  };

  render() {
    const { reportList, error, errorFromItem } = this.state;
    if (error) {
      throw new Error(t('dashboard.report_status.error'));
    }

    return (
      <div
        className="bx--row, ReportStatusList-row"
        aria-label={t('dashboard.section_widgets_aria_label')}
        role="region"
      >
        {errorFromItem && (
          <div className="bx--row">
            <div className="bx--col-lg-12">
              <InlineNotification
                title={t('error.error')}
                subtitle={t('dashboard.report_status.error')}
                hideCloseButton={false}
                kind="error"
              />
            </div>
          </div>
        )}
        <div className="bx--row">
          {reportList.map((item, idx) => (
            <ReportStatusWithRowCount
              reportItem={item}
              key={item.idx}
              listIndex={idx}
              errorInReportItem={this.callbackOnReportItemError}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default ReportStatusList;
